module.exports = __webpack_public_path__ + "img/classify_img2.7af7f9ef.png";